import i18n from '@core/plugins/i18n';

export const getters = {
  boostedProductGuidsForPeriod: ({ productBoostList }) => (startDate, endDate) => productBoostList.reduce((guidSet, pb) => {
    if (pb.canBeApplied(startDate, endDate)) guidSet.add(pb.productGuid);
    return guidSet;
  }, new Set()),
  getSaleZoneNamesByRateGuid: ({ saleRateList }) => (saleRateGuid) => saleRateList.find((rate) => rate.guid === saleRateGuid)?.saleZoneNames,
  masterSaleFormatList: ({ masterSaleFormatList }) => masterSaleFormatList,
  pointOfSaleSettings: (state) => state.pointOfSaleSettings,
  saleRateList: (state) => state.saleRateList,
  saleZoneList: (state) => state.saleRateList.flatMap((rate) => rate.sale_zones),
  serviceList: (state) => state.serviceList,
  masterProductList: (state) => state.masterProductList,
  editableProductList: (state) => state.masterProductList.filter((product) => product.is_new || product.is_menu_enabled),
  menuEnabledProductList: (state) => state.masterProductList.filter((product) => product.is_menu_enabled),
  managedProductList: (state) => state.masterProductList.filter((product) => product.is_managed),
  masterProductListCancelToken: (state) => state.masterProductListCancelToken,
  masterProductProgress: (state) => state.masterProductProgress,
  predictionPeriodList: (state) => state.predictionPeriodList,
  getServiceNameByGuid: ({ serviceList }) => (guid) => {
    const serviceFound = serviceList.find((service) => service.guid === guid);
    return serviceFound ? serviceFound.name : i18n.t('services');
  },
  nextPeriod: (state) => state.predictionPeriodList.find((el) => new Date(el.startDate) > new Date()) || state.predictionPeriodList[0],
  lastTwoPastPeriods: (state) => {
    const previousPeriods = state.predictionPeriodList.filter((p) => p.isPreviousPeriod);
    previousPeriods.sort((a, b) => b.endDate - a.endDate);
    const firstPastPeriod = previousPeriods[0];
    const secondPastPeriod = previousPeriods[1];
    const lastTwoPastPeriods = [];
    // Append first past period and then the second past period, in that order
    if (firstPastPeriod) lastTwoPastPeriods.push(firstPastPeriod);
    if (secondPastPeriod) lastTwoPastPeriods.push(secondPastPeriod);
    return lastTwoPastPeriods;
  },
  newProducts: (state) => state.newProducts,
  groupOfProductPricingList: (state) => state.groupOfProductPricingList,
  menuList: (state) => state.menuList,
};
